

export function Processing(note, button_id, duration = 600) {

    let n = 15;
    let note_item = note
    let note_list = []
    for (let i = 0; i < n; i++) {
        note_item = note_item + '.'
        note_list.push(note_item)
    }
    let index = 0
    let element = document.getElementById(button_id);
    let processing = setInterval(() => {
        index += 1;
        element.value = note_list[index % n];
    }, duration);

    return processing;
}

